import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { OrderDirection } from '../../Datatable/OrderDirection';
import SurveyorQueryModel from '../models/SurveyorQueryModel';
import SurveyorModel from '../models/SurveyorModel';
import { QueryItem } from '../../Tonnage/models/TonnageQueryModel';

interface surveyorSearchState {
    query: SurveyorQueryModel,
    searchResults: SurveyorModel[],
    surveyorSearchKeyword: string,
    triggerSearch: number,
    selectedSurveyors: SurveyorModel[],
    datatableSelectedIndex: number,
    searchResultTotalRecord: number,
    triggerFocusCompanyName: number
    checkedSurveyors: SurveyorModel[],
}

const initialState: surveyorSearchState = {
    query: {
        surveyorNames: [],
        portNames: [],
        countries: [],
        orderBy: "updatedDate",
        orderDirection: OrderDirection.Desc,
    } as SurveyorQueryModel,
    searchResults: [],
    surveyorSearchKeyword: "",
    selectedSurveyors: [],
    triggerSearch: 0,
    datatableSelectedIndex: -1,
    searchResultTotalRecord: 0,
    triggerFocusCompanyName: 0,
    checkedSurveyors: []
}

export const SurveyorSearchSlice = createSlice({
    name: "SurveyorSearch",
    initialState,
    reducers: {
        setSurveyorNames: (state, action: PayloadAction<QueryItem[]>) => {
            state.query.surveyorNames = action.payload;
        },
        setPortNames: (state, action: PayloadAction<QueryItem[]>) => {
            state.query.portNames = action.payload;
        },
        setCountries: (state, action: PayloadAction<QueryItem[]>) => {
            state.query.countries = action.payload;
        },
        setOrderBy: (state, action: PayloadAction<string>) => {
            state.query.orderBy = action.payload;
        },
        setOrderDirection: (state, action: PayloadAction<OrderDirection>) => {
            state.query.orderDirection = action.payload;
        },
        setSurveyorSearchResults: (state, action: PayloadAction<SurveyorModel[]>) => {
            state.searchResults = action.payload;
        },
        setTriggerSurveyorSearch: (state, action: PayloadAction<number>) => {
            state.triggerSearch = action.payload;
        },
        setSurveyorSearchKeyword: (state, action: PayloadAction<string>) => {
            state.surveyorSearchKeyword = action.payload;
        },
        setDatatableSelectedSurveyorIndex: (state, action: PayloadAction<number>) => {
            state.datatableSelectedIndex = action.payload;
        },
        setSearchResultTotalRecord: (state, action: PayloadAction<number>) => {
            state.searchResultTotalRecord = action.payload;
        },
        setSurveyorquery: (state, action: PayloadAction<SurveyorQueryModel>) => {
            state.query = action.payload;
        },
        resetSurveyorSearch: (state) => {
            state.query = initialState.query;
        },
        setSelectedSurveyors: (state, action: PayloadAction<SurveyorModel[]>) => {
            state.selectedSurveyors = action.payload;
        },
        setTriggerFocusCompanyName: (state, action: PayloadAction<number>) => {
            state.triggerFocusCompanyName = action.payload;
        },
        setCheckedSurveyors: (state, action: PayloadAction<SurveyorModel[]>) => {
            state.checkedSurveyors = action.payload;
        },
    }
});

export const SurveyorSearchSelector = createSelector(
    (state: RootState) => state.surveyorSearch,
    (data) => data
);

export const {
    setCountries,
    setSurveyorNames,
    setPortNames,
    setOrderBy,
    setSurveyorSearchKeyword,
    setOrderDirection,
    setSurveyorSearchResults,
    setTriggerSurveyorSearch,
    setDatatableSelectedSurveyorIndex,
    setSearchResultTotalRecord,
    setSurveyorquery,
    resetSurveyorSearch,
    setSelectedSurveyors,
    setTriggerFocusCompanyName,
    setCheckedSurveyors
} = SurveyorSearchSlice.actions;

export default SurveyorSearchSlice.reducer;